import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useState } from 'react';
import Collapse from '../../../components/Collapse';
import CollapseTrigger from '../../../components/CollapseTrigger';
export default function SuccessSection({ title, summary, children }) {
    const [open, setOpen] = useState(true);
    const id = useId();
    const headingId = `${id}-heading`;
    return (_jsxs("section", { className: "opc-success-section border-top border-gray-light", children: [_jsx("h3", { className: "font-size-body font-weight-bold mb-0", children: _jsx(CollapseTrigger, { id: headingId, className: "opc-success-disclosure p-0 line-height-base", open: open, controls: id, onClick: () => setOpen(previous => !previous), children: title }) }), summary, _jsx(Collapse, { open: open, id: id, labelledBy: headingId, children: _jsx("div", { className: "pt-3", children: children }) })] }));
}
